module.exports = __webpack_public_path__ + "static/media/image-1200.cfd75d08.webp";